// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__N6mHL","overlab__header":"header_overlab__header__EKN1e","active":"header_active__SjreC","navlinks__header":"header_navlinks__header__pdtAo"};